export type SessionStatusFilter = "all" | "active" | "completed";
const sessionDate = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Asia/Tashkent",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

type SessionFilterRow = {
  username: string;
  login_at: string;
  duration_seconds: number;
  online: boolean;
};

export function tashkentSessionDate(value: string) {
  const parts = sessionDate.formatToParts(new Date(value));
  const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${values.year}-${values.month}-${values.day}`;
}

export function filterSessions<T extends SessionFilterRow>(rows: T[], start: string, end: string, username: string, status: SessionStatusFilter) {
  return rows.filter((item) => {
    const loginDate = tashkentSessionDate(item.login_at);
    const dateMatches = (!start || loginDate >= start) && (!end || loginDate <= end);
    const userMatches = username === "all" || item.username === username;
    const statusMatches = status === "all" || (status === "active" ? item.online : !item.online);
    return dateMatches && userMatches && statusMatches;
  });
}

export function averageSessionDuration(rows: SessionFilterRow[]) {
  return rows.length ? rows.reduce((total, item) => total + Math.max(0, item.duration_seconds), 0) / rows.length : 0;
}
